import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { RoomPriceRankSettingContainer } from "@/components/features/items/price-rank/room/ui/components";

import { useGetRoomPriceRankPageParams } from "./_hooks/use-get-room-price-rank-page-params";

export const RoomPriceRankPage = () => {
	const { hotelID } = useGetRoomPriceRankPageParams();

	return (
		<PageMeta title="部屋料金ランクの設定" url={generatePath(PATHS.HOTEL.ITEMS.ROOM.PRICE_RANK, { hotelID })}>
			<RoomPriceRankSettingContainer hotelID={hotelID} />
		</PageMeta>
	);
};

RoomPriceRankPage.displayName = "RoomPriceRankPage";
